module.exports = __webpack_public_path__ + "img/PL08543.307d7f90.png";